<template>
    <div class="bg-gray-type-5 h-full w-full pb-2">
        <template>
            <div class="pt-10 lg:px-40 px-6 mb-2">
                <h3 class="text-lg font-bold text-dark-type-5">Your event</h3>
                <p class="text-gray-4 text-sm" >All events by you would be displayed here</p>
            </div>
        </template>
        <template>
            <div v-if="loading" class="flex flex-col justify-center items-center h-full w-full">
                <div class="flex items-center justify-center h-screen">
                    <div class="spinner"></div>
                </div>
            </div>
            <div class="pt-10 lg:px-40 px-6 mb-2">
                <div class="grid gap-y-4 gap-4 grid-cols-none lg:grid-cols-3 2xl:grid-cols-5  grid-rows-3 "
                  >
                    <div  v-for="item in event" :key="item.id" class="w-[22.75rem] lg:w-[22.75rem] 2xl:w-[26.75rem] bg-white rounded-lg"
                    :class="{cancelled: item.status == 'cancelled'}" >
                        <router-link 
                        :to="{ name: 'dashboard.view-event', params:{eventId: item.id}}" 
                        >   <img class="img-size" v-if="item.banner == 'null'" src="@/assets/icons/image-placeholder.svg" alt="">
                            <img v-else class="img-size" :src="item.banner">
                        </router-link> 
                            <div class="px-5 pb-5">
                                    <div class="flex items-center justify-between">
                                        <router-link
                                        :to="{ name: 'dashboard.view-event', params:{eventId: item.id}}" 
                                        >
                                            <h3 class="pt-4 font-bold cursor-pointer">{{item.title}}</h3>
                                        </router-link>
                                            <dropdown
                                            placement="bottom-start"
                                            class="inline-block ml-10"
                                            >
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10Z" fill="#444854"/>
                                                <path d="M19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10Z" fill="#444854"/>
                                                <path d="M12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" fill="#444854"/>
                                            </svg>
                                            <div
                                            slot="dropdown" 
                                            class="w-40 px-3 py-4 mt-2 -ml-[8.75rem] text-left bg-white rounded text-dark-type-4"
                                                style="box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1)"  
                                            >
                                                <div class="text-xs font-medium"
                                                style="color: #fc7171"  
                                                    @click="cancelEvent = true"
                                                    >Cancel request</div>
                                                <div v-if="item.status == 'accepted'"
                                                    class="mt-6 text-xs font-medium" 
                                                    @click="copyLink(item.id)" 
                                                >
                                                Copy Link
                                                </div>    
                                                <div v-else
                                                    class="mt-6 text-xs font-medium gray"
                                                >
                                                Copy Link
                                                </div>                  
                                            </div>
                                            </dropdown>
                                    </div>
                                    <div class="mb-2"> 
                                        <div class="border-b border-gray-9">
                                            <div class="text-sm py-3 text-gray-4" v-html="span(item.description)"/>
                                            <p class="text-xs text-gray-4 font-medium pb-4">Created on: {{item.createdAt}}</p>
                                        </div>
                                        <p v-if="item.status == 'pending'" class="text-sm text-[#E7C805] pt-5">Request pending</p>
                                        <p v-if="item.status == 'accepted'" class="text-sm text-active pt-5">Request accepted</p>
                                        <p v-if="item.status == 'queried'" class="text-sm text-gray-type-9 pt-5">Request queried</p>
                                
                                    <div v-if="item.status == 'rejected'" class="flex justify-between">
                                        <p  class="text-sm text-[#E13D45] pt-5">Request rejected</p>
                                        <p  class="text-sm text-[#4848ED] pt-5 cursor-pointer" @click="showAdminFeedback = true">View feedback</p>
                                    </div>

                                    </div>   
                            </div>
                            <modal :show="cancelEvent" modal-class="admin-feedback-modal">
                                <div class="p-5" v-if="feedback">
                                    <div class="flex flex-col items-center text-center">
                                        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="4" y="4" width="48" height="48" rx="24" fill="#FEE4E2"/>
                                        <path d="M34 22L22 34M22 22L34 34" stroke="#D92D20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <rect x="4" y="4" width="48" height="48" rx="24" stroke="#FEF3F2" stroke-width="8"/>
                                        </svg>
                                        <h3 class="text-lg font-medium pt-5">Cancel Request</h3>
                                        <p class="text-sm text-[#667085] py-2">Are you sure you want to cancel this request? This action cannot be undone.</p>
                                        <div class="flex flex-col items-center lg:flex-row w-full justify-evenly">
                                            <button class="block w-full lg:w-44 h-9 py-2 mb-2 lg:mb-0 font-medium text-center text-[#344054] text-sm border border-[#D0D5DD] rounded" 
                                                @click="cancelEvent = false"
                                            >Dismiss</button>
                                            <button class="block w-full lg:w-44 h-9 py-2 font-medium text-center text-white text-sm bg-[#D92D20] rounded" @click="(feedback = false, cancelRequest(item.id))">Proceed</button>
                                        </div>
                                    </div>    
                                </div>
                                <div v-else class="relative px-6 py-3 pb-6 text-dark-type-4">
                                    <div class="mt-1 flex items-center flex-col">
                                        <div class="my-1">
                                        <img src="@/assets/icons/refund-success.svg">
                                        </div>
                                        <div class="text-center">
                                            <h3 class="text-lg font-normal text-dark-type-3">Event request cancelled</h3>
                                            <p class="text-base text-dark-type-4">
                                                Your event was has been cancelled, you can create a new event
                                            </p>
                                        </div>
                                    </div>    
                                    <button
                                    @click="reset"
                                    class="block w-full h-12 py-4 mt-8 font-medium text-center text-black text-sm bg-active rounded"
                                    >Dismiss</button>
                                </div>   
                            </modal>
                    </div>
                </div> 
            </div>
           
        </template>     
        <template v-if="emptyState" class="bg-white rounded-lg w-[39.313rem] p-7 m-auto">
                <div class="flex flex-col justify-center items-center">
                    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="4" y="4" width="48" height="48" rx="24" fill="#F0F0FF"/>
                    <path d="M37 37L32.65 32.65M35 27C35 31.4183 31.4183 35 27 35C22.5817 35 19 31.4183 19 27C19 22.5817 22.5817 19 27 19C31.4183 19 35 22.5817 35 27Z" stroke="#4848ED" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    <rect x="4" y="4" width="48" height="48" rx="24" stroke="#FAFAFF" stroke-width="8"/>
                    </svg>
                    <h3 class="text-lg">No event found</h3>
                    <p class="text-center text-sm text-[#667085] p-2">Do you have an event coming up, and you would love to use our services?</p>
                    <router-link
                        :to="{name:'dashboard.create-event'}"
                        class="flex justify-center items-center w-1/3 h-12 p-1 mt-4 text-center text-black text-sm bg-active rounded"
                        >
                        <img class="mr-2" src="@/assets/icons/add.svg">
                        Create event</router-link>
                </div>
        </template>
        <modal :show="showAdminFeedback" modal-class="admin-feedback-modal">
            <div class="p-5">
                <div class="text-center">
                    <h3 class="text-lg font-medium ">Admin Feedback</h3>
                    <p class="text-base text-gray-type-8 pt-2 pb-8">We would like to apologize, your request was rejected because we currently do not have any means of handling your event request.</p>
                    <button class="block w-full h-12 py-4 mt-8 font-medium text-center text-black text-sm bg-active rounded" @click="showAdminFeedback = false">Close</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import axios from "@/services/axios";
import { mapGetters } from "vuex";
import Dropdown from "@/components/Dropdown";
import Modal from "@/components/Modal";


 export default{
    name: "ManageEvent",
    components:{
        Dropdown,
        Modal,
    },
    data: () => {
        return {
            event: [],
            showAdminFeedback: false,
            cancelEvent: false,
            feedback: true,
            loading: false,
            emptyState: false
        }
    },
    computed: {
        ...mapGetters("auth", ["user"])
    },
    methods: {
       async getAllEvents(){
        this.loading = true
         try{
            let res = await axios.get(`https://api.test.shuttlers.africa/event/users/${this.user.id}/events`)
                if(res.status == 200){
                   let r = res.data.data 
                   r.forEach((item) => {
                    let event = new Date(item.createdAt)
                    item.createdAt = event.toDateString()
                   })
                   this.event = r
                }    
                this.checkEvents()    
         } catch(err){
            console.log(err)
         }
         finally{this.loading = false}
        },
         async cancelRequest(id){
            try{
                await axios.post('https://api.test.shuttlers.africa/event/admin/event/cancel',{
                        eventId : id,
                        feedback: `This event was canceled by the ${this.user.id}`
                })
            } 
            catch(err){
                console.log(err)
            }   
        },
        copyLink(id){
            let baseText = "https://test.shuttlers.africa/join-event";
            navigator.clipboard.writeText(`${baseText}/${id}`);
            this.$toast.success(
                        `Link copied, ${baseText}/${id}`
            );      
        },
        checkEvents(){
            if(this.event.length == 0){
                    this.emptyState = true
                }
        },
        reset(){
            this.cancelEvent = false
            setTimeout(()=>{
                this.feedback = true
            }, 400)
        },
         span(text) {
                return `<span> ${text} </span>`
        }
    },
    created(){
        this.getAllEvents()
    }
 }
</script>

<style lang="scss" scoped>

.gray{
    color: #ACAFAE;
    cursor: none;
}
.greyedOut{
 background-color: #ACAFAE;
}

.img-size{
    width: 428px;
    height: 180px;
    border-radius: 10px 10px 0px 0px;
    object-fit: cover;
}
.cancelled{
    display: none;
}


</style>

<style>
.admin-feedback-modal {
  @apply sm:max-w-md;
}
</style>